import { memo } from 'react';
import { Table } from 'rsuite';
import styles from './UsersPagination.module.scss';

const Pagination = memo(Table.Pagination);

type UsersPaginationProps = {
  total: number;
  pageSize: number;
  page: number;
  onChangePage: (page: number) => void;
};

export const UsersPagination = ({ total, pageSize, page, onChangePage }: UsersPaginationProps) => {
  if (total <= pageSize) return null;

  return (
    <Pagination
      className={styles.pagination}
      total={total}
      displayLength={pageSize}
      activePage={page}
      showLengthMenu={false}
      showInfo={false}
      first
      prev
      next
      last
      ellipsis
      boundaryLinks
      maxButtons={3}
      onChangePage={onChangePage}
    />
  );
};
